import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDashboard = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M5.66675 21C4.20842 21 3.816 20.8368 3.4895 20.5105C3.16317 20.184 3 19.7916 3 19.3333V12.5833H10.1668V21H4.66675ZM11.8333 21V12.5833H21V19.3333C21 19.7916 20.8368 20.184 20.5105 20.5105C20.184 20.8368 19.7916 21 19.3333 21H11.8333ZM3 10.9167V4.66675C3 4.20842 3.16317 3.816 3.4895 3.4895C3.816 3.16317 4.20842 3 4.66675 3H19.3333C19.7916 3 20.184 3.16317 20.5105 3.4895C20.8368 3.816 21 4.20842 21 4.66675V10.9167H3Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgDashboard);
export default ForwardRef;
